import React from "react"
import { Link } from "gatsby"

export default() => (
    <header className="header">
        <h1 className="heading heading--jumbo cursor">
            <Link to="/">Olivia Cheng</Link>
        </h1>
    </header>
)
